import Filter from 'components/Filter'
import { Form, Formik } from 'formik';
import QueryString from 'qs';
import React from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import classes from "./style.module.scss"
import { get } from 'lodash';
import * as Fields from 'components/Fields';
import Button from 'components/Button';

export default function Filters() {
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation();
    const { filter = {} } = QueryString.parse(location.search, { ignoreQueryPrefix: true })

    const setParams = (values) => {
        const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
        history.push({
            pathname: location.pathname,
            search: QueryString.stringify({
                ...query,
                filter: { ...Object(filter), ...values }
            })
        });
    };

    return (
        <div>
            <Filter title={t('date')} value={get(filter, 'date')} onClear={() => setParams({ date: undefined })}>
                {({ close }) => (
                    <Formik initialValues={{ date: '' }} onSubmit={setParams}>
                        {() => (
                            <Form>
                                <div className={classes.dropdown}>
                                    <div className={classes.title}>{t('Search_by_date')}</div>
                                    <div className={classes.subtitle}>{t('Enter_date')}</div>
                                    <div className={classes.field}>
                                        <Fields.Date label={t('date')} name="date" />
                                    </div>
                                    <div className={classes.buttonList}>
                                        <Button className={classes.button} variant="stroke" onClick={close}>{t('Cancel')}</Button>
                                        <Button className={classes.button} variant="blue" onClick={close}>{t('Search')}</Button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                )}
            </Filter>
        </div>
    )
}
